export default "__VITE_ASSET__Bolyj84q__"